import React, { useState } from 'react';
import logo from '../assets/logo.png';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();

  const token = localStorage.getItem('gymtoken');

  return (
    <nav className="bg-gray-900 p-4">
      <div className="container mx-auto flex justify-between items-center">
        {/* Logo */}
        <button className="text-white text-2xl font-bold" onClick={() => navigate('/')}>
            <img
            src={logo} alt="Logo" className="h-20"/>
        </button>

        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8 text-white items-center">
          <button className="hover:text-[#fded22]" onClick={() => navigate('/')}>Home</button>
          <button className="hover:text-[#fded22]" onClick={() => navigate('/plans')}>Plans</button>
          <button className="hover:text-[#fded22]"  onClick={() => navigate('/about')}>About Us</button>
          {token ? (
            <>             
            <button className="hover:text-[#fded22]" onClick={() => navigate('/admindashboard')}>Dashboard</button>
            
          <button className="bg-[#fded22] py-2 text-black px-4 rounded-full font-semibold hover:bg-white" onClick={() => {localStorage.removeItem('gymtoken'); navigate('/login')}}>Logout</button>
          </>

          ) : (
            <button className="bg-[#fded22] py-2 text-black px-4 rounded-full font-semibold hover:bg-white" onClick={() => navigate('/login')}>Login</button>
          )}
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)} className="text-white focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={isOpen ? 'M6 18L18 6M6 6l12 12' : 'M4 6h16M4 12h16M4 18h16'} />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {isOpen && (
        <div className="md:hidden">
          <button className="block w-full text-right text-white px-4 py-2 hover:bg-gray-700 hover:text-[#fded22]" onClick={() => {navigate('/'); setIsOpen(false)}}>Home</button>
          <button className="block w-full text-right text-white px-4 py-2 hover:bg-gray-700 hover:text-[#fded22]" onClick={() => {navigate('/plans'); setIsOpen(false)}}>Plans</button>
          <button className="block w-full text-right text-white px-4 py-2 hover:bg-gray-700 hover:text-[#fded22]" onClick={() => {navigate('/about'); setIsOpen(false)}}>About Us</button>
          {token ? (
            <>
            <button className="block w-full text-right text-white px-4 py-2 hover:bg-gray-700 hover:text-[#fded22]" onClick={() => {navigate('/admindashboard'); setIsOpen(false)}}>Dashboard (Admin)</button>
            <button className="block w-full text-right text-white px-4 py-2 hover:bg-gray-700 hover:text-[#fded22]" onClick={() => {localStorage.removeItem('gymtoken'); navigate('/login'); setIsOpen(false)}}>Logout</button>
            </>
          ) : (
            <button className="block w-full text-right text-white px-4 py-2 hover:bg-gray-700 hover:text-[#fded22]" onClick={() => {navigate('/login'); setIsOpen(false)}}>Login</button>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;

